// The dialog's three modes: their words and their marks.

import { ArrowDownIcon, ArrowsDownUpIcon, CreditCardIcon } from '@phosphor-icons/react'

export type ExchangeTab = 'deposit' | 'buy' | 'convert'

export interface Mode {
  key: ExchangeTab
  label: string
}

export const TABS: readonly Mode[] = [
  { key: 'deposit', label: 'Deposit' },
  { key: 'buy', label: 'Buy' },
  { key: 'convert', label: 'Convert' },
]

/** A mode's mark: a plain glyph, the same in every list of the modes. */
export function ModeMark({ tab, size = 18 }: { tab: ExchangeTab; size?: number }) {
  if (tab === 'deposit') return <ArrowDownIcon size={size} weight="bold" aria-hidden="true" />
  if (tab === 'buy') return <CreditCardIcon size={size} weight="bold" aria-hidden="true" />
  return <ArrowsDownUpIcon size={size} weight="bold" aria-hidden="true" />
}
